import { HttpMethod } from 'src/app/common/model/http-method';

export class ImageViewerInput {

    constructor(public readonly method: HttpMethod, public title: string, public translateDescription: boolean,
        public readonly imageSourceAndDescription: ImageSourceAndDescription[]) { }

}

export class ImageSourceAndDescription {
    constructor(public readonly description: Map<string, string>, public readonly link: string, public readonly imageName: string) { }
}
